<template>
  <div class="empty-box">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'empty-box'
}
</script>

<style scoped lang="less">
.empty-box {
  background: white;
  padding: 24px;
  margin: 24px 0px;
  border-radius: 2px;
}
</style>
